<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-lg-8 col-md-12 sol-sm-12 mb-3">
              <h5 class="card-title">Unapproved Time Cards</h5>
            </div>
            <div class="col-lg-4 col-md-12 sol-sm-12">
              <div class="row">
                <div
                  class="col-lg-12 col-md-12 sol-sm-12 text-left text-lg-right"
                >
                  <label class="mr-2">Sort by: </label>
                  <button
                    v-for="field in sortableFields"
                    :key="field"
                    :class="[
                      'btn',
                      'btn-primary',
                      'mr-2',
                      { active: sortField === field }
                    ]"
                    @click="sortBy(field)"
                  >
                    {{ field }}
                    <i
                      class="icon-arrow-up5 ml-2"
                      v-if="sortField === field && sortDirection === 'asc'"
                    ></i>
                    <i
                      class="icon-arrow-down5 ml-2"
                      v-else-if="
                        sortField === field && sortDirection === 'desc'
                      "
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <button v-on:click="testIsaac()">test</button> -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <label>Filter by: </label>
            </div>

            <div class="col-lg-6 col-md-6 sol-sm-12">
              <div class="form-group">
                <input
                  v-model="searchName"
                  placeholder="Search by name"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-2 sol-sm-12">
              <div class="form-group">
                <v-select
                  :options="types"
                  v-model="selectedEmployeeType"
                  label="name"
                  placeholder="Employee Type"
                ></v-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 sol-sm-12">
              <div class="form-group">
                <v-select
                  :options="employeeCategories"
                  v-model="selectedEmployeeCategory"
                  label="name"
                  placeholder="Employee Category"
                  class="dark_text"
                  multiple
                ></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <timeCard
      v-for="(timeCard, index) in getFilteredItems"
      v-bind:key="timeCard.id"
      v-bind:index="index"
      v-bind:id="timeCard.id"
      v-bind:date="timeCard.date"
      v-bind:approved="timeCard.approved"
      v-bind:times="timeCard.times"
      v-bind:name="timeCard.name"
      v-bind:type="timeCard.type"
      v-bind:category="timeCard.category"
      v-bind:dateApproved="timeCard.dateApproved"
      v-bind:lastRegTime="lastRegTime"
      v-bind:otIndex="otIndex"
      v-bind:approvedBy="timeCard.approvedBy"
      v-bind:timeSpanTypes="timeSpanTypes"
      v-bind:holidays="holidays"
      v-bind:vacation="timeCard.vacation"
      v-bind:uid="timeCard.uid"
      v-bind:incomplete="timeCard.incomplete"
      v-bind:showLocation="true"
      v-bind:passedEditComment="timeCard.editComment"
      :averagingAgreement="
        timeCard.averagingAgreement ? timeCard.averagingAgreement : null
      "
      :automationsApplied="
        timeCard.automationsApplied ? timeCard.automationsApplied : null
      "
      :users="users"
      ref="timeCardCollection"
      @deleteTimeCard="deleteTimeCard"
      v-bind:timeCard="timeCard"
    ></timeCard>
  </div>
</template>

<script>
import timeCard from '../components/timeCard.vue';

import { db } from '../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../assets/js/helpers/holidays.js';

export default {
  name: 'unApprovedTimeCards',
  components: {
    timeCard
  },
  data() {
    return {
      timeCardCollection: null,
      lastRegTime: null,
      otIndex: null,
      timeSpanTypes: [],
      holidays: [],
      isaacToken: null,
      users: [],
      searchName: '',
      types: [],
      selectedEmployeeType: null,
      employeeCategories: [],
      selectedEmployeeCategory: null,
      sortField: '',
      sortDirection: {},
      sortableFields: ['name', 'date']
    };
  },
  methods: {
    searchCards: function() {
      try {
        //create the query based off of the selections.
        this.timeCardCollection = [];

        //get the list of holidays for the year that the user has selected.
        getHolidays(moment().format('YYYY'))
          .then(response => {
            for (
              let i = 0;
              i <= response.data.provinces[0].holidays.length - 1;
              i++
            ) {
              this.holidays.push(response.data.provinces[0].holidays[i].date);
            }
          })
          .catch(() => {
            console.log(`Error getting holidays`);
          });

        //run out to the store and grab a pack of time cards.
        db.collection('timeCards')
          .where('approved', '==', false)
          .where('company', '==', this.$store.state.userCompany)
          .orderBy('date', 'desc')
          .get()
          .then(querySnapshot => {
            let tempArg = [];
            querySnapshot.forEach(doc => {
              let complete = true;
              //if the showIncompleteTimeCards setting is true, then we need to make a fake end time and append the time card to the list.
              for (let i = 0; i <= doc.data().times.length - 1; i++) {
                if (doc.data().times[i].endTime == null) {
                  complete = false;
                }
              }
              if (complete) {
                //only going to display time cards that have an end time on this.
                tempArg.push({
                  id: doc.id,
                  date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  times: doc.data().times,
                  approved: doc.data().approved,
                  approvedBy:
                    doc.data().approvedBy == undefined
                      ? null
                      : doc.data().approvedBy,
                  name: doc.data().name,
                  type: doc.data().type,
                  category: doc.data().userCategory,
                  dateApproved:
                    doc.data().dateApproved == undefined
                      ? null
                      : moment(doc.data().dateApproved.toDate()).format(
                          'MMM DD, YY hh:mm'
                        ),
                  vacation: doc.data().vacation,
                  incomplete: false,
                  uid: doc.data().user,
                  averagingAgreement: doc.data().averagingAgreement
                    ? doc.data().averagingAgreement
                    : null,
                  editComment:
                    doc.data().editComment != undefined
                      ? doc.data().editComment
                      : null,
                  automationsApplied: doc.data().automationsApplied
                    ? doc.data().automationsApplied
                    : null
                });
              } else if (
                this.$store.state.showIncompleteTimeCards == 'Yes' &&
                complete == false
              ) {
                let placeHolderTime = doc.data().times;
                placeHolderTime[placeHolderTime.length - 1].endTime = moment(
                  placeHolderTime[placeHolderTime.length - 1].startTime.toDate()
                ).endOf('day');
                tempArg.push({
                  id: doc.id,
                  date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  times: placeHolderTime,
                  approved: doc.data().approved,
                  approvedBy:
                    doc.data().approvedBy == undefined
                      ? null
                      : doc.data().approvedBy,
                  name: doc.data().name,
                  type: doc.data().type,
                  category: doc.data().userCategory,
                  dateApproved:
                    doc.data().dateApproved == undefined
                      ? null
                      : moment(doc.data().dateApproved.toDate()).format(
                          'MMM DD, YY hh:mm'
                        ),
                  vacation: doc.data().vacation,
                  incomplete: true,
                  uid: doc.data().user,
                  averagingAgreement: doc.data().averagingAgreement
                    ? doc.data().averagingAgreement
                    : null,

                  editComment:
                    doc.data().editComment != undefined
                      ? doc.data().editComment
                      : null,
                  automationsApplied: doc.data().automationsApplied
                    ? doc.data().automationsApplied
                    : null
                });
              }
            });
            let sum = 0;
            for (let i = 0; i <= tempArg.length - 1; i++) {
              //itterate all of the times can get a total.
              let daysum = moment.duration();
              for (let t = 0; t <= tempArg[i].times.length - 1; t++) {
                tempArg[i].times[t] = {
                  times: [
                    //this is special formating for the javascript date object. This removes the seconds and miliseconds from it.
                    tempArg[i].times[t].startTime != null
                      ? tempArg[i].times[t].startTime.toDate()
                      : '',
                    tempArg[i].times[t].endTime != null
                      ? tempArg[i].times[t].endTime.toDate()
                      : ''
                  ],
                  type: tempArg[i].times[t].type,
                  job: tempArg[i].times[t].job ? tempArg[i].times[t].job : null,
                  notes: tempArg[i].times[t].notes,
                  typeError: false,
                  typeMessage: null,
                  dateError: false,
                  dateMessage: null,
                  startLocation: {
                    latitude:
                      tempArg[i].times[t].startLocation != undefined
                        ? tempArg[i].times[t].startLocation.latitude
                        : null,
                    longitude:
                      tempArg[i].times[t].startLocation != undefined
                        ? tempArg[i].times[t].startLocation.longitude
                        : null
                  },
                  endLocation: {
                    latitude:
                      tempArg[i].times[t].endLocation != undefined
                        ? tempArg[i].times[t].endLocation.latitude
                        : null,
                    longitude:
                      tempArg[i].times[t].endLocation != undefined
                        ? tempArg[i].times[t].endLocation.longitude
                        : null
                  }
                };
                let start = moment(tempArg[i].times[t].startTime);
                let end = moment(tempArg[i].times[t].endTime);
                daysum.add(moment.duration(end.diff(start)).asHours());
              }
            }
            //this is the time card that will go over the weekly maximum
            this.timeCardCollection = tempArg;
          })
          .catch(err => {
            console.log(err);
          });
      } catch (error) {
        this.showError('Error getting time cards.');
      }
    },
    deleteTimeCard: function(index) {
      this.timeCardCollection.splice(index, 1);
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    sortBy(field) {
      try {
        if (this.sortField === field) {
          this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortDirection = 'asc';
        }

        this.sortField = field;

        this.getFilteredItems.sort((a, b) => {
          return this.compareItemsByField(a[field], b[field]);
        });
      } catch (error) {
        this.showError('An error occurred while sorting:', error);
      }
    },

    compareItemsByField(a, b) {
      try {
        if (this.sortField === 'name') {
          const comparison = a.toLowerCase().localeCompare(b.toLowerCase());
          return this.sortDirection === 'asc' ? comparison : -comparison;
        } else if (this.sortField === 'date') {
          const dateA = moment(a, 'MMM DD, YY').toDate();
          const dateB = moment(b, 'MMM DD, YY').toDate();
          const comparison = dateA - dateB;
          return this.sortDirection === 'asc' ? comparison : -comparison;
        }
        return 0;
      } catch (error) {
        this.showError('An error occurred while comparing items:', error);
      }
    },
    async getEmployeeCategories() {
      try {
        const querySnapshot = await db
          .collection('employeeCategories')
          .where('org', '==', this.$store.state.userCompany)
          .orderBy('name', 'asc')
          .get();

        querySnapshot.forEach(doc => {
          this.employeeCategories.push({
            name: doc.data().name
          });
        });
      } catch (error) {
        console.log(`Error getting employee categories: ${error}`);
        this.showError('Error getting employee categories');
      }
    },

    async getUserTypes() {
      try {
        const querySnapshot = await db
          .collection('userTypes')
          .orderBy('name', 'asc')
          .get();

        querySnapshot.forEach(doc => {
          this.types.push({
            name: doc.data().name
          });
        });
      } catch (error) {
        console.log(`Error getting user types: ${error}`);
        this.showError('Error getting user types');
      }
    }
  },

  async mounted() {
    await this.getEmployeeCategories();
    await this.getUserTypes();

    //get the user list.
    await db
      .collection('users')
      .where('company', '==', this.$store.state.userCompany)
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (this.$store.state.showInactiveEmployees == 'Yes') {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement ? true : false
            });
          } else if (
            doc.data().deactiveDate == undefined ||
            doc.data().deactiveDate == null
          ) {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement ? true : false
            });
          }
        });
      })
      .catch(err => {
        console.log(`Error getting users: ${err}`);
      });
    this.searchCards();
    //get the time span types for the timecard edits.
    db.collection('timeSpanTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.timeSpanTypes.push(doc.data().name);
        });
      })
      .catch(err => {
        console.log(`Error getting time span types: ${err}`);
      });
  },
  computed: {
    timeCardUpdated() {
      return this.$store.state.timeCardUpdated;
    },
    getFilteredItems() {
      //sorting items from timeCardCollection
      try {
        let filteredTimeCards = this.timeCardCollection;

        if (this.searchName) {
          const filteredUsers = this.users.filter(user => {
            return user.name
              .toLowerCase()
              .includes(this.searchName.toLowerCase());
          });

          filteredTimeCards = filteredTimeCards.filter(timeCard => {
            return filteredUsers.some(user => user.id === timeCard.uid);
          });
        }

        if (this.selectedEmployeeType) {
          const selectedTypeNames = Array.isArray(this.selectedEmployeeType)
            ? this.selectedEmployeeType.map(type => type.name)
            : [this.selectedEmployeeType.name];

          filteredTimeCards = filteredTimeCards.filter(timeCard => {
            return selectedTypeNames.includes(timeCard.type);
          });
        }

        if (
          this.selectedEmployeeCategory &&
          this.selectedEmployeeCategory.length > 0
        ) {
          filteredTimeCards = filteredTimeCards.filter(timeCard => {
            return this.selectedEmployeeCategory.some(selectedCategory => {
              return timeCard.category.some(
                cardCategory => cardCategory.name === selectedCategory.name
              );
            });
          });
        }
        return filteredTimeCards;
      } catch (error) {
        this.showError('Error getting filtered items: ', error);
        return this.timeCardCollection;
      }
    }
  },
  watch: {
    timeCardUpdated(newValue) {
      if (newValue) {
        this.searchCards();
        this.$store.dispatch('setTimeCardUpdated', false);
      }
    }
  }
};
</script>
<style>
.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100% - 40px);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}
</style>
